import TYPES from '../types'

const initialState = {
  data: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0
  }
}

const OrderData = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ALT_ORDER_LISTS:
      return {
        ...state,
        data: action.data.data || [],
        pagination: action.data.pagination || initialState.pagination
      }
    
    case TYPES.LOGOUT:
      return initialState
    
    default:
      return state
  }
}

export default OrderData
